import { createSlice } from '@reduxjs/toolkit'

const profileWillMountSlice = createSlice({
  name: 'profileWillMount',
  initialState: {
    isProfileUpdated: false
  },
  reducers: {
    handleProfileWillMount: (state) => {
      state.isProfileUpdated = !state.isProfileUpdated
    }
  }
})

export const { handleProfileWillMount } = profileWillMountSlice.actions
export default profileWillMountSlice.reducer
